var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckboxChecked = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  rx: 3
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m13.36 6.299-4.721 4.603L6.596 8.91a1.116 1.116 0 0 0-1.589 0 1.05 1.05 0 0 0 0 1.55L8.64 14l6.354-6.152a1.05 1.05 0 0 0 0-1.55c-.5-.398-1.18-.398-1.634 0",
  clipRule: "evenodd"
})));
export { SvgCheckboxChecked as ReactComponent };